// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__HtusT","header":"ReportDetails_header__1C4g5","title":"ReportDetails_title__1Qrc8","left":"ReportDetails_left__w5Zx1"};